import React, { useEffect, useState } from 'react';
import { Paper, Typography, TextField, Button, Stack, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { api } from '../../api';

// Редактор правил бронювання майстра. Префіл — поточні правила (або вбудований дефолт).
export default function BookingTermsEditor({ masterId }) {
  const { t } = useTranslation();
  const [text, setText] = useState('');
  const [isDefault, setIsDefault] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  useEffect(() => {
    if (!masterId) return;
    let alive = true;
    api.getBookingTerms(masterId)
      .then((d) => { if (alive) { setText(d.text || ''); setIsDefault(!!d.isDefault); } })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [masterId]);

  const save = async () => {
    setErr(''); setMsg('');
    if (!text.trim()) { setErr(t('terms.editorEmpty')); return; }
    setSaving(true);
    try {
      await api.updateBookingTerms(masterId, text);
      setIsDefault(false);
      setMsg(t('terms.editorSaved'));
    } catch (e) {
      setErr(e.message || t('terms.editorSaveError'));
    }
    setSaving(false);
  };

  return (
    <Paper sx={{ p: 2, mb: 3, bgcolor: '#faf7f2', border: '1px solid rgba(28,29,23,0.12)' }}>
      <Typography variant="h6" gutterBottom>{t('terms.editorTitle')}</Typography>
      <Typography variant="body2" sx={{ color: '#57564d', mb: 1.5 }}>
        {t('terms.editorHint')}{isDefault ? ` ${t('terms.editorDefaultNote')}` : ''}
      </Typography>
      {msg && <Alert severity="success" sx={{ mb: 1 }} onClose={() => setMsg('')}>{msg}</Alert>}
      {err && <Alert severity="error" sx={{ mb: 1 }} onClose={() => setErr('')}>{err}</Alert>}
      <TextField
        multiline
        minRows={10}
        maxRows={26}
        fullWidth
        value={text}
        onChange={(e) => setText(e.target.value)}
        disabled={loading}
        placeholder={t('terms.editorPlaceholder')}
        sx={{ '& textarea': { fontFamily: 'inherit', fontSize: 14, lineHeight: 1.5 } }}
      />
      <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
        <Button variant="contained" onClick={save} disabled={saving || loading}>
          {saving ? t('common.saving') : t('common.save')}
        </Button>
      </Stack>
    </Paper>
  );
}
